import React from 'react'
import Chapterpages from '../../../../Chapter/pages/chapterpages'

export default function ChapterUserpage() {
    return (
        <>

            <Chapterpages />
        </>
    )
}
